import { useEffect, useState } from "react";
import api from "../lib/api";
import ParcoursCard from "../components/ParcoursCard";

export default function Parcours() {
    const [pc, setPc] = useState([]);

    useEffect(() => {
        api.get("/parcours", { params: { limit: 50 } }).then((r) => setPc(r.data)).catch(() => {});
    }, []);

    return (
        <div className="pt-28" data-testid="parcours-page">
            <section className="px-6 md:px-12 max-w-[1600px] mx-auto pt-16 md:pt-24 pb-16">
                <p className="cp-tiny text-cp-foret mb-8">Chapitre VIII · Parcours thématiques</p>
                <h1 className="cp-serif text-4xl sm:text-5xl md:text-[56px] lg:text-[72px] xl:text-[92px] leading-[1.02] text-cp-encre max-w-5xl tracking-[-0.025em]">
                    Vins, whisky,<br /><em className="cp-display-italic text-cp-foret">jardins</em> secrets.
                </h1>
                <p className="cp-serif italic text-xl md:text-2xl font-light text-cp-gris leading-relaxed mt-12 max-w-3xl">
                    Des itinéraires cousus main — trois haltes, quatre haltes, sept haltes — pour ceux qui veulent une journée, un week-end, un dimanche <em>parfait</em>.
                </p>
            </section>

            <section className="px-6 md:px-12 max-w-[1600px] mx-auto pb-32">
                <div className="flex flex-col gap-24 md:gap-28">
                    {pc.map((p, i) => <ParcoursCard key={p.id} parcours={p} index={i} />)}
                </div>
            </section>
        </div>
    );
}
